import { NavLink, useParams,useLocation } from "react-router";
import FondsItemComponent from "../../components/Fonds/FondsItem";
import { useFondByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import { useAuth } from "../../contexts/auth/useAuth";
import type { LocationState } from "../../types/QueryParameters";

function FondItem(){
    const location = useLocation();
    const state=location.state as LocationState | undefined ;
    const params = useParams();
    const { data:fond , error, isLoading } = useFondByIdQuery(params.fondId??"0");
    const {translate}=useTrads();
        const { user } = useAuth();
    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : fond ? (


       
            <div>
                {fond.id_inscription==user?.id?
                <nav>
                    <NavLink to={`/fond/${fond.id.toString()}/edit`}>{translate('btn_edit')}</NavLink>
                </nav>
                :null}
                {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_fond_update')}</p>}
            <FondsItemComponent fond={fond}  />
            </div>
       
        ):null
    );
}
export default FondItem;